import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
export var OWNER_COMPLAINT_TYPE_FIELD = {
  field: {
    label: 'Ссылка на объявление',
    name: EFormFieldsNames.OwnerComplaintType,
    type: EExtendedFieldTypes.OwnerOfferLinkField
  },
  validation: yup.string()
};